import styled, { css } from 'styled-components'

import { device } from '~/styles/device'

import { FormGroup } from '../unform'

export const DateWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;

    > div {
      display: flex;
      position: relative;

      @media ${device.mobileL} {
        + div {
          margin-left: 2rem;
        }
      }

      &.start {
        @media ${device.mobileL} {
          &::after {
            content: '';
            position: absolute;
            background-color: ${theme.colors.tertiary};

            height: 1px;
            width: 1rem;
            bottom: 1rem;
            right: -1.5rem;
          }
        }
      }

      &.checkbox {
        @media ${device.mobileL} {
          max-height: 2rem;
          align-self: flex-end;
          padding-bottom: 5px;
        }

        > div {
          margin-right: -0.5rem;
        }
      }
    }

    @media ${device.mobileL_max} {
      flex-direction: column;
      gap: 1rem;
    }
  `}
`

export const FormGroupDate = styled(FormGroup)`
  display: flex;
  flex-direction: column;
`

export const TooltipWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`
